<template>
    <div class="iframe-container">
      <iframe :src="iframeSrc" width="100%" height="100%"></iframe>
    </div>
  </template>
  
  <script>
  import { SignJWT } from 'jose';
  
  // Funzione per codificare la chiave base64 in Uint8Array
  const base64ToUint8Array = (base64) => {
    const padding = '='.repeat((4 - (base64.length % 4)) % 4);
    const base64Cleaned = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64Cleaned);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };
  
  // Funzione per generare il token
  const generateToken = async (payload, secretKeyBase64) => {
    const secretKey = base64ToUint8Array(secretKeyBase64);
    const jwt = await new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256' })
      .sign(secretKey);
    return jwt;
  };
  
  export default {
    name: 'EPFinder',
    data() {
      return {
        token: '',
        username: localStorage.getItem('user') || '', // Ottieni il nome utente dal localStorage
      };
    },
    async mounted() {
      console.log(this.username.toLowerCase());
      await this.loadVar();
    },
    computed: {
      iframeSrc() {
        return `https://www.e-photo.site?token=${this.token}`;
      }
    },
    methods: {
      async loadVar() {
        const payload = {
          email: this.username.toLowerCase(),
          role: 'PRODUCER',
          customers: [this.username.toLowerCase()],
        };
        const secretKeyBase64 = 'sWfwokN4oteptfyi3HjyNFX9IUOwKhElJkW3GMpJvvY=';
        this.token = await generateToken(payload, secretKeyBase64);
        //console.log('Generated token:', this.token);
      }
    }
  };
  </script>
  
  <style scoped>
  .iframe-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  iframe {
    border: none;
    margin-top: 0px;
    margin-left: 0px;
    min-height: 900px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  
  @media (max-width: 600px) {
    iframe {
      margin-top: 0px;
      margin-left: 0px;
      width: 100%;
      min-height: 700px;
    }
  }
  </style>
  